import { Col, Form } from "antd";
import { Link } from "react-router-dom";

import Button from "@ui/form-controls/button";
import { UsernameOrEmailValidation } from "constants/promptRules";

import { useRequestPasswordReset } from "../../hooks/use-request-password-reset";
import AuthShell from "../auth-shell";
import TextField from "@ui/form-controls/text-field";

const RequestPasswordResetForm = () => {
  const { alertType, form, handleSubmit, loading, message } = useRequestPasswordReset();

  return (
    <AuthShell
      alertType={alertType}
      loading={loading}
      message={message}
      pageClassName="min-h-screen min-w-[100vw] m-0 bg-white overflow-y-scroll"
      spinClassName="loaderGifPosition min-w-[80%]"
      title="Request Reset Password"
    >
      <Form className="w-full" form={form} onFinish={handleSubmit}>
        <Form.Item name="usernameEmail" rules={UsernameOrEmailValidation}>
          <TextField placeholder="Please enter username or email" size="lg" />
        </Form.Item>

        <Form.Item>
          <Button size="lg" variant="primary" htmlType="submit" className="w-full">
            Submit
          </Button>
        </Form.Item>

        <Col className="flex justify-center">
          <Link type="primary" to="/login">
            Home
          </Link>
        </Col>
      </Form>
    </AuthShell>
  );
};

export default RequestPasswordResetForm;
